import { saveAs } from 'file-saver';

export const blobToFile = (blob, fileName) => {
  return new File([blob], fileName, {
    lastModified: new Date().getTime(),
    type: blob.type,
  });
};

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString() || "");
    reader.onerror = (error) => reject(error);
  });


export const convertBinaryToExcel = async (binaryData, fileName = 'generated_excel') => {
  // try {

  //   const blob = new Blob([binaryData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  //   // Create a download link
  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = window.URL.createObjectURL(blob);

  //   downloadLink.download = `${fileName}.xlsx`;
  //   await document.body.appendChild(downloadLink);

  //   await downloadLink.click();
  // } catch (error) {
  //   console.error('Error converting binary to Excel:', error);
  // }

  try {
    console.log("binaryData", binaryData.length)
    const blob = new Blob([binaryData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Save the Blob as a file using file-saver
    saveAs(blob, fileName);
  } catch (error) {
    console.error('Error converting binary to Excel:', error);
  }
};

export const hasCommonScope = (routerScopes, userScopes) => {
  for (const scope of userScopes) {
    if (routerScopes?.includes(scope)) {
      // console.log('TESTT Permissions', routerScopes, userScopes, scope, routerScopes.includes(scope))
      return true;
    }
  }

  return false;
};


export const getCurrentLocation = (opts = {}) =>
  new Promise((resolve) => {
    // Works only on HTTPS (or localhost) and needs user permission
    if (typeof navigator === "undefined" || !("geolocation" in navigator)) {
      return resolve({ error: "Geolocation not supported" });
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
      ...opts,
    };

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        resolve({
          latitude: coords.latitude,
          longitude: coords.longitude,
          accuracy: coords.accuracy,
        });
      },
      (err) => {
        // Don’t reject — resolve with an error so callers can decide fallbacks
        resolve({
          error:
            err.code === 1
              ? "Permission denied"
              : err.code === 2
                ? "Position unavailable"
                : err.code === 3
                  ? "Timeout"
                  : err.message || "Unknown error",
        });
      },
      options
    );
  });
